// Basic
import { useState } from 'react';
// Store & actions
import useSessionStore from '@/app/store/session';
import useSubscriptionStore from '@/app/store/modules/subscription';
// Components
import Page from '@/common-utils/components/structure/page/Page';
import PageActions from '@/common-utils/components/renders/pageActions/PageActions';
import SubscriptionsTable from '@/app/modules/subscriptions/components/tables/SubscriptionsTable';
import ModalMultipleBlockingPos from '@/app/modules/terminals/components/modals/multipleBlocking/ModalMultipleBlockingPos';
import ModalMutipleRewarehouse from '@/app/modules/terminals/components/modals/multipleRewarehouse/ModalMutipleRewarehouse';
import ModalMultipleActivationPos from '@/app/modules/terminals/components/modals/multipleActivation/ModalMultipleActivationPos';
import ModalImport from '@/common-utils/components/renders/dataTable/import/ModalImport';
import MultipleBlockingPosImportProps from '@/app/modules/terminals/components/import/MultipleBlockingPosImportProps';
// Common
import RouteUrls from '../enums/RouteUrls';
import ICONS from '@/common-utils/enums/icons';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
import Permissions from '@/app/permissions/Permissions';
import setFiltersEventName from '@/common-utils/components/renders/dataTable/utils/setFiltersEventName';
// Lang
import { nsTerminal } from '@/app/i18n/namespaces';

/**
 * @returns {JSX} CustomPayPosTerminals
 */
function CustomPayPosTerminals() {

    // Store
    const session = useSessionStore(s => s.session);
    const permissions = session.permissions;
    const storeRefetchSubscriptions = useSubscriptionStore(s => s.storeRefetchSubscriptions);

    // State
    const [showModalMultipleRewarehouse, setShowModalMultipleRewarehouse] = useState(false);
    const [showModalMultipleBlocking, setShowModalMultipleBlocking] = useState();
    const [showModalMultipleActivation, setShowModalMultipleActivation] = useState();
    const [showModalMultipleBlockingByCsv, setShowModalMultipleBlockingByCsv] = useState(false);

    return (
        <Page>
            <Page.Header
                route={RouteUrls.SUBSCRIPTIONS}
                routeBase={RouteUrls.SUBSCRIPTIONS}
            />
            <Page.Body dataCy='page-terminals'>
                <SubscriptionsTable
                    filtersEventName={setFiltersEventName('subscriptions')}
                    pageActions={
                        <PageActions actions={[
                            {
                                icon: ICONS.POS_TERMINAL_ACTIVATE,
                                entity: 'actions.page.multiple_activation',
                                namespace: nsTerminal,
                                onClick: () => setShowModalMultipleActivation(true),
                                visible: true,
                                disabled: !hasRequiredPermissions({
                                    permissions: permissions,
                                    requiredPermissions: [
                                        Permissions.SUBSCRIPTION_ACTIVATE.name,
                                        Permissions.SUBSCRIPTION_PLAN_ADD_CLIENT.name,
                                        Permissions.SUBSCRIPTION_PLAN_LIST_CLIENT_PLANS.name
                                    ]
                                }),
                                tooltipForbidden: 'title.permissions.access_denied'
                            },
                            {
                                icon: ICONS.IN_STOCK,
                                entity: 'actions.page.multiple_rewarehouse',
                                namespace: nsTerminal,
                                onClick: () => setShowModalMultipleRewarehouse(true),
                                visible: true,
                                disabled: !hasRequiredPermissions({
                                    permissions: permissions,
                                    requiredPermissions: [Permissions.SUBSCRIPTION_REWAREHOUSE.name, Permissions.SUBSCRIPTION_LIST.name]
                                }),
                                tooltipForbidden: 'title.permissions.access_denied'
                            },
                            {
                                isDropdown: true,
                                visible: true,
                                trigger: {
                                    icon: ICONS.BLOCK,
                                    entity: 'actions.page.multiple_block.title',
                                    namespace: nsTerminal,
                                    variant: 'critical',
                                    visible: true,
                                    disabled: !hasRequiredPermissions({
                                        permissions: permissions,
                                        requiredPermissions: [Permissions.BLACKLIST_ADD_ENTRY.name]
                                    }),
                                    tooltipForbidden: 'title.permissions.access_denied'
                                },
                                subActions: [
                                    {
                                        entity: 'actions.page.multiple_block.select',
                                        namespace: nsTerminal,
                                        onClick: () => setShowModalMultipleBlocking(true),
                                        visible: true,
                                        disabled: !hasRequiredPermissions({
                                            permissions: permissions,
                                            requiredPermissions: [Permissions.BLACKLIST_ADD_ENTRY.name]
                                        }),
                                        tooltipForbidden: 'title.permissions.access_denied'
                                    },
                                    {
                                        entity: 'actions.page.multiple_block.upload',
                                        namespace: nsTerminal,
                                        onClick: () => setShowModalMultipleBlockingByCsv(true),
                                        visible: true,
                                        disabled: !hasRequiredPermissions({
                                            permissions: permissions,
                                            requiredPermissions: [Permissions.BLACKLIST_ADD_ENTRY.name]
                                        }),
                                        tooltipForbidden: 'title.permissions.access_denied'
                                    }
                                ]
                            }
                        ]}
                            retractable
                        />
                    } />
            </Page.Body>
            {showModalMultipleBlocking &&
                <ModalMultipleBlockingPos
                    isOpen={showModalMultipleBlocking}
                    setIsOpen={setShowModalMultipleBlocking}
                />
            }
            {showModalMultipleBlockingByCsv &&
                <ModalImport
                    isOpen={showModalMultipleBlockingByCsv}
                    setIsOpen={setShowModalMultipleBlockingByCsv}
                    importProps={{ ...MultipleBlockingPosImportProps, setLaunchRefetch: storeRefetchSubscriptions }}
                />
            }
            {showModalMultipleRewarehouse &&
                <ModalMutipleRewarehouse
                    isOpen={showModalMultipleRewarehouse}
                    setIsOpen={setShowModalMultipleRewarehouse}
                />
            }
            {showModalMultipleActivation &&
                <ModalMultipleActivationPos
                    isOpen={showModalMultipleActivation}
                    setIsOpen={setShowModalMultipleActivation}
                />
            }
        </Page >
    );
}

export default CustomPayPosTerminals;